export default "__VITE_ASSET__DBXxZp2O__"